





















import Vue from 'vue';
import store from '../store';

export default Vue.component('bacon-progress', {
    computed: {
        progressPercent() {
            return Math.ceil(store.state.progress * 100);
        },
        progressCssWidth() {
            let width = Math.ceil(store.state.progress * 100) + '%';
            if (store.state.progress <= 0) {
                width = '1px';
            }
            return { width };
        },
        progressCssPos() {
            if (store.state.progress <= 0.5) {
                return {
                    left: Math.ceil(store.state.progress * 100) + '%',
                };
            }
            return {
                right: (100 - Math.ceil(store.state.progress * 100)) + '%',
            };
        },
        productsCount() {
            return store.state.productsCount;
        },
        productSingle() {
            return store.state.productsCount === 1;
        },
    },
});
